// Mixpanel event names
export const MIXPANEL_SERVER_EVENT_NAMES = {
  SIGNUP: 'signup',
  REFERRAL_SIGNUP: 'referral_signup',
  LOGIN: 'login',
  START_CODING: 'start_coding',
  FINISH_CODING: 'finish_coding',
  CHECKOUT: 'checkout',
  ORDER_SUCCESS: 'order_success',
  SUBSCRIBE_SUCCESS: 'subscribe_success',
}

export const MIXPANEL_CLIENT_EVENT_NAMES = {
  CLICK_BUY_ADDON_USAGE_HISTORY_PAGE: 'click_buy_addon_usage_history_page',
  PAGE_VIEW: 'page_view',
  CLICK_DESIGN_SYSTEM_BUTTON: 'click_design_system_button',
  VERIFY_DOMAIN_SUCCESS: 'verify_domain_success',
  CLICK_SIGNIN: 'click_signin',
  CLICK_VERIFY_CODE: 'click_verify_code',
  CLICK_SIGNUP: 'click_signup',
  CLICK_LOGIN: 'click_login',
  CLICK_LOGOUT: 'click_logout',
  CLICK_PROFILE_MENU: 'click_profile_menu',
  REMIX_PROJECT: 'remix_project',
  CLICK_UNDO_BUTTON_PROJECT_PREVIEW: 'click_undo_button_project_preview',
  CLICK_REDO_BUTTON_PROJECT_PREVIEW: 'click_redo_button_project_preview',
  CLICK_DATABASE_BUTTON_PROJECT_PREVIEW:
    'click_database_button_project_preview',
  CLICK_EDIT_BUTTON_PROJECT_PREVIEW: 'click_edit_button_project_preview',
  CLICK_EXPORT_PROJECT: 'click_export_project',
  CLICK_PROJECT_PROMPT_SUGGESTION: 'click_project_prompt_suggestion',
  CLICK_UPDATE_SCREENSHOT: 'click_update_screenshot',
  PUBLISH_PROJECT: 'publish_project',
  CLICK_ADD_NEW_DOMAIN: 'click_add_new_domain',
  CLICK_USE_TEMPLATE: 'click_use_template',
  UPLOAD_ASSETS: 'upload_assets',
  CLICK_UPLOAD_BUTTON_AI_CHAT: 'click_upload_button_ai_chat',
  CLICK_SELECT_BUTTON_AI_CHAT: 'click_select_button_ai_chat',
  CLICK_CONTACT_SUPPORT_BUTTON_AI_CHAT: 'click_contact_support_button_ai_chat',
  RESTORE_PROJECT: 'restore_project',
  CLICK_FREE_CREDITS_BUTTON: 'click_free_credits_button',
  CLICK_TOOLBOX_TAB: 'click_toolbox_tab',
  CLICK_EDIT_SAVE_BUTTON_PROJECT_PREVIEW:
    'click_edit_save_button_project_preview',
  CLICK_REMOVE_TARGET_EDITOR: 'click_remove_target_editor',
  CLICK_ENABLE_SEO_BUTTON: 'click_enable_seo_button',
  CLICK_SUBSCRIBE_BUTTON_SEO: 'click_subscribe_button_seo',
  CLICK_PROFILE_MENU_AVATAR: 'click_profile_menu_avatar',
  CLICK_PROFILE_MENU_SUBSCRIPTIONS: 'click_profile_menu_subscriptions',
  CLICK_PROFILE_MENU_CONTACT_SUPPORT: 'click_profile_menu_contact_support',
  CLICK_PROFILE_MENU_HELP_CENTER: 'click_profile_menu_help_center',
  CLICK_ELEMENT_LIBRARY_ASSET: 'click_element_library_asset',
  CLICK_ELEMENT_LIBRARY_AI_GENERATE: 'click_element_library_ai_generate',
  CLICK_FEATURE_BUTTON: 'click_feature_button',
  WATCH_DEMO: 'watch_demo',
  SUBMIT_PROMPT: 'submit_prompt',
  GENERATE_PROJECT: 'generate_project',
  CLICK_BACK_HOME_DIALOG: 'click_back_home_dialog',
  CLICK_REFERENCE_DESIGN_HOME_PAGE: 'click_reference_design_home_page',
  CLICK_SKIP_HOME_DIALOG: 'click_skip_home_dialog',
  CLICK_START_BUILDING_HOME_DIALOG: 'click_start_building_home_dialog',
  PLAN_PROJECT: 'plan_project',
  SELECT_PROJECT_TYPE_HOME_PAGE: 'select_project_type_home_page',
  UPLOAD_REFERENCE_DESIGN_HOME_PAGE: 'upload_reference_design_home_page',
  INPUT_PROMPT_HOME_PAGE: 'input_prompt_home_page',
  CLICK_START_BUILDING_HOME_PAGE: 'click_start_building_home_page',
  CLOSE_PERSONALIZE_HOME_DIALOG: 'close_personalize_home_dialog',
  SKIP_PERSONALIZE_HOME_PAGE: 'skip_personalize_home_page',
  START_PERSONALIZE_HOME_PAGE: 'start_personalize_home_page',
  VIEW_LATEST_PROJECTS: 'view_latest_projects',
  VIEW_LOGIN_MODAL: 'view_login_modal',
  CLICK_PREVIEW_TEMPLATE_COPY_URL: 'click_preview_template_copy_url',
  CLICK_PREVIEW_TEMPLATE_SWITCH_DESKTOP:
    'click_preview_template_switch_desktop',
  CLICK_PREVIEW_TEMPLATE_SWITCH_MOBILE: 'click_preview_template_switch_mobile',
  CLICK_BUY_ADDON_PRICING_PAGE: 'click_buy_addon_pricing_page',
  CLICK_UPGRADE_PLAN_BUTTON: 'click_upgrade_plan_button',
  CLICK_MANAGE_SUBSCRIPTION_BUTTON: 'click_manage_subscription_button',
  CLICK_ANNUAL_BILLING_SWITCH_BUTTON: 'click_annual_billing_switch_button',
  CLICK_CONNECT_STRIPE_BUTTON: 'click_connect_stripe_button',
  CLICK_SEND_MESSAGE: 'click_send_message',
  CLICK_DOWNLOAD_CODE: 'click_download_code',
  CLICK_CODE_EDITOR: 'click_code_editor',
  PREVIEW_PROJECT: 'preview_project',
  USE_SKILL: 'use_skill',
}
